var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"12","md":"7"}},[_c('BlobFeed')],1),_c('v-col',{attrs:{"cols":"12","offset-md":"1","md":"4"}},[_c('RadarList')],1)],1),_c('v-row',[_c('v-col',[_c('BlobSuggestionCarousel')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }